export const WEBAPIMETHOD = {
  TimeOut: (action: any, duration: number) => {
    let timerId: ReturnType<typeof setTimeout> | null = null;

    return {
      Perform: () => {
        timerId = setTimeout(() => action(), duration);
      },
      Clear: () => {
        if (timerId !== null) clearTimeout(timerId);
      }
    }
  },

  Interval: (action: any, duration: number) => {
    let intervalId: ReturnType<typeof setInterval> | null = null;

    return {
      Perform: () => {
        intervalId = setInterval(() => action(), duration);
      },
      Clear: () => {
        if (intervalId !== null) clearInterval(intervalId);
      }
    }
  }
}